import create, { State, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

export const createStore = <TState extends State>(store: StateCreator<TState>, storeName: string) =>
  create<TState>(process.env.NODE_ENV === 'development' ? devtools(store, storeName) : store);
